import { Autocomplete, Icon } from "@shopify/polaris";
import { SearchIcon } from "@shopify/polaris-icons";
import { useState, useMemo, useEffect } from "react";
import { debounce } from "lodash";

function Search({ onSearch }) {
  const [inputValue, setInputValue] = useState("");

  // Debounce the search function
  const debouncedSearch = useMemo(
    () =>
      debounce((query) => {
        onSearch(query);
      }, 300),
    [onSearch]
  );

  const updateText = (value) => {
    setInputValue(value);
    debouncedSearch(value);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const textField = (
    <Autocomplete.TextField
      onChange={updateText}
      label=""
      value={inputValue}
      prefix={<Icon source={SearchIcon} tone="base" />}
      placeholder="Search"
      autoComplete="off"
    />
  );

  // Render without options for debugging
  return <Autocomplete options={[]} textField={textField} />;
}

export default Search;
